/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('textsearch-chip', {
    template: `<!--ko foreach: phrases--><label data-bind="html: $data, click: $parent.remove"></label><!--/ko-->`,
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new TextSearchChipViewModel(params, componentInfo);
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
function TextSearchChipViewModel(params, componentInfo) {
  var self = this;

  self.phrases = ko.observableArray($.grep(params.data.Phrases().split(','), function (e) {
    return !e == false;
  }));

  params.data.Phrases.subscribe(function () {
    self.phrases($.grep(params.data.Phrases().split(','), function (e) {
      return !e == false;
    }));
  });

  this.remove = function (data, event) {
    var $form = $(event.currentTarget).closest('form');

    var v = ',' + params.data.Phrases() + ',';

    v = v.replace(',' + this + ',', ',');
    v = v.substring(0, v.length - 1);
    v = v.substring(1);
    params.data.Phrases(v);

    $form.trigger('update');
  };
}
